import { createElement } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * Custom.
 *
 * Main component parameters type.
 * Extend TypographyProps for 'div' with custom properties
 */
export type ContentProps = {
    prose?: 'normal' | 'xl';
    component?: React.ElementType;
} & JSX.IntrinsicElements['div'];

/**
 * Custom helper component.
 *
 * Use this when content is generated by authors / translators. Like synopsis, novel announcements etc...
 */
function ContentComponent({ className, children, component, prose = 'xl', ...rest }: ContentProps) {
    return createElement(
        component || 'div',
        {
            ...rest,
            prose,
            className: twMerge('fr-view prose max-w-none dark:prose-invert', className),
        },
        children
    );
}

export default ContentComponent;
//#endregion : Main component
